import type { FaireProductEntity } from "../../entity_types/product";

export const p_qncqrejnw8: FaireProductEntity = {
  token: "p_qncqrejnw8",
  type: "product",
  name: "Classic Panettone - Net wt 35,27oz",
  brandToken: "b_yrvj5ect2z",
  brandName: "OLIVIERI 1882  (Audax 1882 LLC)",
  imageUrl:
    "https://cdn.faire.com/fastly/3679a121f378107635a5d97b5c9edf1a87797f94efc9706be05fcf043b4e97b3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d1a87e3b0245b0756fc0b9ecf3de91fa44f92d13fb7c55ce174da7c8a3b365d7.jpeg",
    "https://cdn.faire.com/fastly/584f5195a40e5932d324d53da75c17ac41cdc8080bfc148173b9138069c26e86.jpeg",
    "https://cdn.faire.com/fastly/474a42e6ab06cf2a4c9c90ff33755b0cd920d7bbf3f7185d7fe20322dbbfdfd6.jpeg",
    "https://cdn.faire.com/fastly/d5e4cb4b49be3239cef3fb546908e2f1f5ff3bc2ec2892b4b432fcc45efd4797.jpeg",
  ],
  priceDollars: 44.5,
  description:
    "Classic Panettone Olivieri 1882 –  Italian Christmas Cake\n\nOur Classic Panettone Olivieri 1882 is a celebration of authentic Italian tradition. Made exclusively with natural sourdough and allowed to rise for over 48 hours, it offers an incredibly soft texture and a refined, aromatic taste.\n\nInside, you’ll discover premium 5 Crowns Australian raisins and candied orange peels, delicately enhanced with specks of Madagascar Bourbon vanilla.\n\nThough rich and fragrant, our panettone is light and easy to digest, thanks to the extended fermentation and our commitment to using only the finest raw ingredients.\n\t•\tNo preservatives\n\t•\tNo semi-finished products\n\t•\tNo artificial flavorings\n\t•\tNo vegetable fats\n",
  tags: [],
  msrpDollars: 90,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:26.724Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
